import { Carousel } from '@design-system/carousel';
import { CtaBlock } from '@design-system/cta-block';
import { PageBlock } from '@design-system/page-block';
import React, { forwardRef } from 'react';

import { ItemListingCarouselProps } from '../models';

export const ItemListingRails = forwardRef<
  HTMLDivElement,
  ItemListingCarouselProps
>(({ pageBlock, carousel, id, showMore, uid }, ref) => (
  <PageBlock
    {...pageBlock}
    className="item-listing-rails-block"
    id={id}
    componentUid={uid}
    ref={ref}
  >
    <Carousel
      {...carousel}
      ariaLivePlaceholder={(activeIndex, totalCount) =>
        `Show ${activeIndex} of ${totalCount}`
      }
    />
    {showMore ? <CtaBlock align="center" {...showMore} /> : null}
  </PageBlock>
));

export default ItemListingRails;
